import { ConfirmDialog } from '../ConfirmDialog';
import { useUnsavedDraftGuard } from './useUnsavedDraftGuard';

export const DiscardDraftDialog = ({
  open,
  onDiscard,
  onKeep
}: ReturnType<typeof useUnsavedDraftGuard>['discardDialog']) => (
  <ConfirmDialog
    open={open}
    title="Discard unsaved changes?"
    message="The line items or monthly total you entered haven't been saved."
    confirmLabel="Discard"
    cancelLabel="Keep editing"
    onConfirm={onDiscard}
    onCancel={onKeep}
  />
);
